<template>
  <div class="baniere pt-20 pb-26">
    <div class="md:flex flex-wrap">
      <div
        v-for="(item, index) in equipe"
        :key="index"
        class="md:w-1/3 md:mb-0 mb-10 imag"
      >
        <images
          class="images w-full"
          :info="item"
        />
      </div>
    </div>

    <div class="flex justify-center w-full mt-24 pb-32">
      <div
        class="button mt-6 md:w-1/5 w-4/5 mb-4"
        @click="openProjet"
      >
        Rejoindre la Team
      </div>
    </div>
  </div>
</template>

<script>
import images from '@/components/cedo/equipe/images'
import moudilou from '../../../assets/images/jpg/moudilou.jpg'
import khaliq from '../../../assets/images/jpg/khaliq.jpg'
import akim from '../../../assets/images/jpg/akim.jpg'
import cedric from '../../../assets/images/jpg/cedric.jpg'
import richard from '../../../assets/images/jpg/richard.jpg'
import sam from '../../../assets/images/jpg/samuel.jpg'
import kevin from '../../../assets/images/jpg/kevin.jpg'
import miguel from '../../../assets/images/jpg/miguel.jpg'
import henoc from '../../../assets/images/jpg/henoc.jpg'
import rigel from '../../../assets/images/jpg/rigel.jpg'
import fredy from '../../../assets/images/jpg/freddy.jpg'
import bm from '../../../assets/images/jpg/bm.jpg'

export default {
  name: 'Index',
  components: {
    images
  },
  props: {
  },
  data () {
    return {
      equipe: [
        {
          name: 'Moudilou Dramane',
          role: 'Directeur Exécutif',
          image: moudilou
        },
        {
          name: 'Bernard-Marie ONZO',
          role: 'Directeur Technique',
          image: bm
        },
        {
          name: 'Khaliq ALI',
          role: 'Chef Projet Mobile',
          image: khaliq
        },
        {
          name: 'Akim Adebissi',
          role: 'Business Developer',
          image: akim
        },

        {
          name: 'Cédric Tokponsi',
          role: 'Lead Web Backend',
          image: cedric
        },
        {
          name: 'Richard Ahounou',
          role: 'Développeur Web',
          image: richard
        },
        {
          name: 'Miguel Davi',
          role: 'Développeur Mobile',
          image: miguel
        },
        {
          name: 'Samuel Hougbegnisse',
          role: 'Designer en Chef',
          image: sam
        },
        {
          name: 'Rigel',
          role: 'Développeur Mobile',
          image: rigel
        },
        {
          name: 'Henoc Alao',
          role: 'Designer UI/UX',
          image: henoc
        },
        {
          name: 'Kevin Nassara',
          role: 'Développeur Web',
          image: kevin
        },

        {
          name: 'Freddy',
          role: 'Développeur Web',
          image: fredy
        }
      ]
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.$router.push('/carriere')
    },

    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $fa;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: white;
  }
  .imag{
   position: relative;
    z-index: 1;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
      min-height: 450px;
      height: auto;
    }
    .button{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .title{
      font-size: 60px;
    }
    .detail{
      font-size: 22px;
    }
    .button{
      width: 34%;
    }
  }
</style>
